/**
 * Reads a non-negative whole-number count from Firestore. Legacy events may
 * store counts as decimal text ("10"), so those are accepted too. Anything
 * else returns null. Mirrors `firestoreCount` in the Flutter app.
 */
export const firestoreCount = (value: unknown): number | null => {
  if (typeof value === "number") {
    return Number.isInteger(value) && value >= 0 ? value : null;
  }
  if (typeof value !== "string") return null;
  const text = value.trim();
  return /^[0-9]+$/.test(text) ? Number(text) : null;
};
